import React from 'react';
import './Hero.css';
import { Carousel } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import premium_1 from '../assets/images/banners/premium_1.png';
import midrange_1 from '../assets/images/banners/mid-range_1.png';
import budget_1 from '../assets/images/banners/budget_1.png';

const bannerImages = [
  {
    src: premium_1,
    headline: "Indulge in Pure Luxury",
    subtitle: "Elevate your wardrobe with our exclusive premium collections.",
    cta: "Shop Premium"
  },
  {
    src: midrange_1,
    headline: "Balance Luxury & Value",
    subtitle: "Experience quality and elegance at a price that makes sense.",
    cta: "Shop Mid-Range"
  },
  {
    src: budget_1,
    headline: "Smart Style, Smart Savings",
    subtitle: "Discover affordable fashion that fits your budget and your life.",
    cta: "Shop Budget"
  }
];

const Hero = ({ onCTAClick, style }) => (
  <section className="hero-section" style={style}>
    <Carousel fade controls={true} indicators={true} interval={5000} className="hero-carousel">
      {bannerImages.map((banner, idx) => (
        <Carousel.Item key={idx}>
          <div className="hero-flex">
            <div className="hero-content">
              <h1 className="hero-title">{banner.headline}</h1>
              <p className="hero-subtitle">{banner.subtitle}</p>
              <button
                className="hero-btn"
                onClick={() => onCTAClick ? onCTAClick(banner, idx) : null}
              >
                {banner.cta}
              </button>
            </div>
            <div className="hero-img-side">
              <img className="hero-img-right" src={banner.src} alt={banner.headline} />
            </div>
          </div>
        </Carousel.Item>
      ))}
    </Carousel>
  </section>
);

export default Hero;
